import Actions from '../../odata/actions';

const actions = new Actions('currencyItem', 'currencyItems');

export default actions;
